module.exports = __webpack_public_path__ + "img/color.d822d15d.png";